const MandatairesListStyle = {
  p: 1,
  width: "100%",
};

export { MandatairesListStyle };
